import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=c92d6bb6&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=ts&"
export * from "./InfoBar.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=c92d6bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92d6bb6",
  null
  
)

export default component.exports